import { render, staticRenderFns } from "./NewRoleMeta.vue?vue&type=template&id=67e47391&scoped=true"
import script from "./NewRoleMeta.vue?vue&type=script&lang=js"
export * from "./NewRoleMeta.vue?vue&type=script&lang=js"
import style0 from "./NewRoleMeta.vue?vue&type=style&index=0&id=67e47391&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e47391",
  null
  
)

export default component.exports